import { RectagularImage } from './SuggestionImage.styles';

export const SuggestionImage = ({ imagePath }: { imagePath: string }) => (
  <RectagularImage
    src={imagePath}
    htmlAttributes={{ draggable: false }}
    imgixParams={{
      fit: 'facearea',
      facepad: 1.4,
    }}
    width={40}
    height={40}
  />
);
